const state = {
  channelUpdate: '',
}
const mutations = {
  CHANNEL_UPDATED (state, payload) {
    state.channelUpdate = payload
  },
}

const actions = {
  channelUpdated ({ state, commit }) {
    commit('CHANNEL_UPDATED', new Date().getTime())
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  strict: true,
}
